import React from 'react';
import { motion } from 'framer-motion';
import { CircleRightArrowIcon, ReviewBox } from './WmwComp';
import Memoji01 from '../img/sec04-memoji01.png';
import Memoji02 from '../img/sec04-memoji02.png';
import Memoji03 from '../img/sec04-memoji03.png';

const WmwSection4 = () => {
  const blogUrl =
    'https://blog.naver.com/PostList.naver?blogId=jebs_jemm&from=postList&categoryNo=36&parentCategoryNo=36';
  return (
    <>
      <div className="bg-gradient-to-b from-[#855AFF] to-[#FFFFFF] flex justify-center p-3 py-10 md:p-12 md:py-20">
        <div className="w-full max-w-[520px]">
          <div className="flex flex-col gap-8 md:gap-12">
            {/* 타이틀 */}
            <section>
              <div className="text-3xl md:text-4xl text-center font-['Pretendard'] text-white">
                왜 <span className="font-bold">WMW</span>인지 알 수 있는
                <div className="font-bold text-[28px] md:text-4xl">
                  동역자들의 수 많은 실제후기!
                </div>
              </div>
            </section>

            {/* 리뷰 컨텐츠 */}
            <section className="flex flex-col gap-3 md:gap-5">
              <ReviewBox img={Memoji01} star={5}>
                <div className="text-[11px] sm:text-sm md:text-base font-['Pretendard'] pr-5">
                  단순히 영어를 가르치는 것을 넘어, 이미 구축되어 있는
                  젭스프로그램을 통해 더 즐거운 과정으로 변했던 것 같아요!
                </div>
              </ReviewBox>

              <ReviewBox img={Memoji02} star={5}>
                <div className="text-xs sm:text-sm md:text-base font-['Pretendard'] pr-5">
                  커리큘럼대로만 진행했더니 정말 아이들이 영어를 재미있어하고
                  영어가 터졌어요!
                </div>
              </ReviewBox>

              <ReviewBox img={Memoji03} star={5}>
                <div className="text-xs sm:text-sm md:text-base font-['Pretendard'] pr-5">
                  주일학교 아이들의 성장을 응원하며 아이들, 학부모, 선생님 모두
                  복음으로 하나 될 수 있었어요!
                </div>
              </ReviewBox>

              <div className="blur-sm">
                <ReviewBox img={Memoji02} star={5} isSmall={true}>
                  <div className="text-xs sm:text-sm md:text-base font-['Pretendard'] pr-5">
                    커리큘럼대로만 진행했더니 정말 아이들이 영어를 재미있어하고
                    영어가 터졌어요!
                  </div>
                </ReviewBox>
              </div>
            </section>

            {/* 버튼 */}
            <section>
              <motion.div
                className="max-w-[280px] max-h-[32px] w-full mx-auto flex justify-center gap-3 items-center rounded-full bg-[#855aff] p-3 md:p-5 cursor-pointer"
                whileHover={{ scale: 1.05, opacity: 0.9 }}
                onClick={() => window.open(blogUrl, '_blank')}
              >
                <div className="text-white text-sm md:text-base font-bold font-['Pretendard']">
                  더 많은 리뷰 보러가기
                </div>
                <CircleRightArrowIcon width={18} color="white" />
              </motion.div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default WmwSection4;
